export default __webpack_public_path__ + "static/media/logo-blanco-alta-.992ddcbf.png";